import { render, staticRenderFns } from "./LoadNsimGT.vue?vue&type=template&id=6c55d6b1"
import script from "./LoadNsimGT.vue?vue&type=script&lang=js"
export * from "./LoadNsimGT.vue?vue&type=script&lang=js"
import style0 from "./LoadNsimGT.vue?vue&type=style&index=0&id=6c55d6b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports